<template>
  <div class="bg-lifeboost-coff-lighter bg-opacity-50 relative w-full flex flex-wrap md:flex-row-reverse text-center">
    <div class="w-full md:w-1/2 px-5 relative flex items-center py-9">
      <div class="w-full space-y-3.5 lg:space-y-5 text-center md:text-left mx-auto">
        <h2 class="text-3xl mx-auto max-w-lg md:text-4xl xl:text-6xl font-ww-medium font-extrabold text-center" v-html="heading"></h2>
        <div class="text-base mx-auto max-w-lg md:text-lg lg:text-2xl text-center font-open-sans" v-html="description"></div>
      </div>
    </div>
    <div class="w-full md:w-1/2 md:ml-auto flex">
      <div class="w-full xl:w-11/12 p-8 lg:p-11 pt-11 lg:pt-16 pb-0 lg:pb-0">
        <div id="" class="aspect-auto">
          <nuxt-img :src="imageSrc"  loading="lazy" format="webp" :alt="imageAlt" class="object-contain block m-auto" width="888" height="628" sizes="xs:256px sm:382px md:701px lg:437px xl:513px 2xl:888px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  heading: {
    type: String,
    default: 'As Healthy <br> as it Gets'
  },
  description: {
    type: String,
    default: 'Some coffee is organic or single origin or shade grown - Lifeboost Coffee meets all ten of our standards for delicious, clean coffee so you enjoy every cup guilt-free.'
  },
  imageSrc: {
    type: String,
    default: '/assets/images/img-11_1.png'
  },
  imageAlt: {
    type: String,
    default: 'As Healthy as it Gets'
  },
});

defineBuilderComponent({
    friendlyName: "Content Left Image",
    inputs: [
        {
            name: "heading",
            type: "richText",
            defaultValue: "As Healthy <br> as it Gets"
        },
        {
            name: "description",
            type: "richText",
            defaultValue: "Some coffee is organic or single origin or shade grown - Lifeboost Coffee meets all ten of our standards for delicious, clean coffee so you enjoy every cup guilt-free."
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/img-11_1.png"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "As Healthy as it Gets"
        }
    ]
});
</script>